import React from 'react';
import { Link } from 'react-router-dom';
import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
import * as constant from '../../constants/constant';
// import Moment from 'react-moment';
import EditRateModal from '../rating/editRating';
import AddRateModal from '../rating/addRating';
import moment from 'moment';
// import momentzone from 'moment-timezone'
import { confirmAlert } from 'react-confirm-alert';
import './help.css'
const size = 10;
let btnSize = { fontSize: 13 };
class PatientAppointmentDetails extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			appointmentData: [],
			rateData: [],
			isAddRateModalOpen: false,
			isEditRateModalOpen: false,
			doctorName: "",
			rateAppId: "",
			rateDrId: "",
			feedbackId: '',
			previousFeedback: ''
		}
		//Add new feedback
		this.closeAddRateModal = this.closeAddRateModal.bind(this);
		this.openAddRateModal = this.openAddRateModal.bind(this);
		this.closeAddRateModalWithNewData = this.closeAddRateModalWithNewData.bind(this);

		//Edit feedback
		this.closeEditRateModal = this.closeEditRateModal.bind(this);
		this.openEditRateModal = this.openEditRateModal.bind(this);
		this.closeEditRateModalWithNewData = this.closeEditRateModalWithNewData.bind(this);
	}
	//Add feedback
	openAddRateModal() {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui disclaimer_appointement'>
						<Link style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></Link>

						<h1>Disclaimer</h1>
						{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
						<span>Your feedback should not identify or make reference to any individual, living or otherwise, in any way, whether in a positive or negative light.  You must also be objective in your feedback, with an emphasis on tangible actions recorded in your feedback post.  The aim of the feedback mechanism is to guide other prospective patients, any official or unofficial complaints should be followed up with Medfix Support Team.  All posts are moderated before being published and may be declined or withdrawn at any time.  Your use of the feedback system constitutes acceptance of the Medfix Terms and Conditions.</span>
						<div className="bottomBtn text-center"><button type="button" onClick={() => {
							var state = this.state;
							state.rateAppId = this.props.match.params.id;
							state.doctorName = (state.appointmentData && state.appointmentData.hasOwnProperty('doctorId') && state.appointmentData.doctorId.userName) ? state.appointmentData.doctorId.userName : '';

							state.rateDrId = (state.appointmentData && state.appointmentData.hasOwnProperty('doctorId') && state.appointmentData.doctorId._id) ? state.appointmentData.doctorId._id : '';

							state.isAddRateModalOpen = true;
							this.setState(state);
							onClose()
						}} className="btn btn-warning btn-lg">Ok</button></div>
					</div>
				)
			}
		})

	}
	closeAddRateModal() {
		this.setState({ isAddRateModalOpen: false });
	}
	closeAddRateModalWithNewData() {

		this.closeAddRateModal();

		let appointmentId = this.props.match.params.id;

		let appointmentObj = {
			appointmentId: appointmentId,
		};
		this.props.actions.getAppointmentDetailWithRate(appointmentObj);
	}
	//Edit feedback
	openEditRateModal() {
		var state = this.state;
		state.rateAppId = this.props.match.params.id;
		state.doctorName = (state.appointmentData && state.appointmentData.hasOwnProperty('doctorId') && state.appointmentData.doctorId.userName) ? state.appointmentData.doctorId.userName : '';

		state.rateDrId = (state.appointmentData && state.appointmentData.hasOwnProperty('doctorId') && state.appointmentData.doctorId._id) ? state.appointmentData.doctorId._id : '';

		state.isEditRateModalOpen = true;
		this.setState(state);
	}
	closeEditRateModal() {
		this.setState({ isEditRateModalOpen: false });
	}
	closeEditRateModalWithNewData() {

		this.closeEditRateModal();

		let appointmentId = this.props.match.params.id;

		let appointmentObj = {
			appointmentId: appointmentId,
		};
		this.props.actions.getAppointmentDetailWithRate(appointmentObj);
	}

	componentWillMount() {

		let appointmentId = this.props.match.params.id;
		let appointmentObj = {
			appointmentId: appointmentId,
		};
		this.props.actions.getAppointmentDetailWithRate(appointmentObj);
	}
	componentDidMount() {


	}
	componentWillReceiveProps(nextProps) {
		var state = this.state;
		state.appointmentData = nextProps.appointmentRateDetail;

		state.rateData = (nextProps.appointmentRateDetail && nextProps.appointmentRateDetail.ratings) ? nextProps.appointmentRateDetail.ratings : state.rateData;

		state.feedbackId = (nextProps.appointmentRateDetail && nextProps.appointmentRateDetail.feedbacks && nextProps.appointmentRateDetail.feedbacks._id) ? nextProps.appointmentRateDetail.feedbacks._id : state.feedbackId;

		state.previousFeedback = (nextProps.appointmentRateDetail && nextProps.appointmentRateDetail.feedbacks && nextProps.appointmentRateDetail.feedbacks.patientFeedback) ? nextProps.appointmentRateDetail.feedbacks.patientFeedback : state.previousFeedback;


		this.setState(state);
	}
	viewReceipt = () => {
		let appointmentId = this.props.match.params.id;
		let appointmentObj = {
			appointmentId: appointmentId,
		};
		this.props.actions.viewReceipt(appointmentObj, this.props);
	}
	// goToDisputePage = (appointmentData) => {
	// 	this.props.history.push(
	// 		{
	// 			pathname:`/disputes/${appointmentData && appointmentData._id}`,
	// 			data: {
	// 				data: this.state.appointmentData
	// 			}
	// 		}
	// 	)
	// }

	render() {
		var appointmentData = this.state.appointmentData;
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<div className="content-wrapper">

				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link to="#tab_1" data-toggle="tab" className="active show">Appointment Details</Link></li>
									</ul>


									<div className="col-md-12">
										<div className="tab-content tabother tspTab">
											<div className="row">

												<div className="col-md-12">

													<div className="searchList  listings tspList" style={{ marginTop: 63 }}>
														{appointmentData && appointmentData.specialistImage ? <div className="searchImg"> {appointmentData.specialistImage && appointmentData.specialistImage == constant.DEFAULT_USER_IMAGE ? <img style={{ marginLeft: 74, marginTop: -33 }} className="profile-user-img img-responsive img-circle" src={appointmentData.doctorId.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'} alt="User profile picture" /> :
															<img style={{ marginLeft: 74, marginTop: -33 }} className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + appointmentData.doctorId._id + '/' + appointmentData.specialistImage} alt="User profile picture" />}

														</div> : ''}



														<div className="row">
															<div style={{ marginLeft: 162 }} className="col-md-12 col-sm-4 col-lg-4 tspBoxBrorder">
																<h3 className="profile-username text-capitalize">Dr. {appointmentData && appointmentData.doctorId ? appointmentData.doctorId.userName : ''}</h3>
																<div style={{ fontSize: 13 }}>
																	<p className="text-capitalize">Patient Name: {appointmentData && appointmentData.patientId ? appointmentData.patientId.userName : ''}</p>
																	{/* <p>Consultation Fee: {appointmentData && appointmentData.availabilitesdet ? appointmentData.availabilitesdet.currencySymbol : ''} {appointmentData ? appointmentData.fee : ""}</p> */}

																	<p>Appointment Date:{appointmentData && appointmentData.appointmentDate ? " " + moment.parseZone(new Date(appointmentData.checkappointmentDate)).format('DD-MM-YYYY') : ''} </p>
																	<p>Appointment Time:{appointmentData && appointmentData.appointmentDate ? " " + moment.parseZone(new Date(appointmentData.checkappointmentDate)).format('hh:mm A') + " " + userlocation: ''}</p>
																	<p>Appointment Mode:{appointmentData && appointmentData.appointmentMode ? appointmentData.appointmentMode == '1' ? ' F2F' : ' Online' : ''}</p>
																</div>
															</div>
															<div className="col-md-12 col-sm-4 col-lg-4">
																{appointmentData ?
																	<div>
																		<ul className="iconhirarchiaddrss">
																			<li className="font-icon-size">	<i className="fa fa-home" aria-hidden="true"></i></li>
																			<li>	{appointmentData.clinicName}</li>
																		</ul>
																		<ul>
																			<li>
																				<i className="fa fa-map-marker"></i>
																			</li>
																			<li>
																				<p></p>
																				<p>{appointmentData.addressLineOne},</p>
																				<p>{appointmentData.city},</p>
																				<p>{appointmentData.state},</p>
																				<p className='capitalize'>{appointmentData.country},</p>
																				<p>{appointmentData.zipcode}</p>

																			</li>
																		</ul>
																		<br />
																		<ul>
																			<li> <img src={require('../../images/img/consultation_fees_icons.png')} alt="" style={{"max-width": "100%"}} /> </li>
																			<li> <p>&nbsp; Consultation Fees {appointmentData ? appointmentData.fee : ''} {appointmentData && appointmentData.availabilitesdet ? appointmentData.availabilitesdet.currencySymbol : ''}</p></li>
																		</ul>
																	</div> : ''}
															</div>
														</div>

													</div>
												</div>
											</div>


											<div className="row">
												{/* <div className="col-md-12 ">
													<div className="tspListBox">
														<div className="tsbBlue">
															<i className="fa"><img src={require('../../images/img/sub_specialities_icon.png')} /></i>Location
														</div>
														<div className="tsbGrayBox capitalize">
															{appointmentData ? <p>{appointmentData.addressLineOne},
																{appointmentData.city},
																	{appointmentData.state},{appointmentData.country},{appointmentData.zipcode}</p> : ''}
														</div>
													</div>
												</div> */}
												<div className="col-md-12 ">
													<div className="tspListBox">
														<div className="tsbBlue">
															<i className="fa"><img src={require('../../images/img/academics.png')} /></i> Symptoms
														</div>
														<div className="tsbGrayBox sym-wrap">
															<p >{appointmentData && appointmentData.symptoms ? appointmentData.symptoms : ''}</p>
														</div>
													</div>
												</div>

												<div className="col-md-12 ">
													<div className="tspListBox">
														<div className="tsbBlue" style={{ width: 300 }}>
															<i className="fa"><img src={require('../../images/img/academics.png')} /></i> Uploaded Documents
														</div>
														<div className="tsbGrayBox">
															{(appointmentData && appointmentData.appointmentdocuments && appointmentData.appointmentdocuments.length > 0) ?
																<div className="row" >
																	<div className="col-md-6">
																		<p style={{ fontWeight: "bold" }}>Document Name</p>
																	</div>
																	<div className="col-md-6">
																		<p style={{ fontWeight: "bold" }}>Document Type</p>
																	</div>
																</div> : ''}

															{(appointmentData && appointmentData.appointmentdocuments && appointmentData.appointmentdocuments.length > 0) ? (appointmentData.appointmentdocuments).map((item, index) =>
																<div key={index}>
																	<div className="row" key={index}>
																		<div className="col-md-6">
																			<Link style={{ color: "#00b5e8" }} to={constant.PRODUCTION_IMAGE_URL + 'uploads/' + appointmentData.patientId._id + '/' + item.documentUrl} target="_blank">{item.documentOriginalName ? item.documentOriginalName : ''}</Link>
																		</div>
																		<div className="col-md-6">
																			<p>{item.documentTypeId ? item.documentTypeId.name : ''}</p>
																		</div>
																	</div>
																</div>
															) : 'You have not uploaded any documents for this appointment'}
														</div>
													</div>
												</div>


												{appointmentData && appointmentData.appointmentStatus == '2' && (appointmentData.ratings && appointmentData.ratings.length > 0) ?
													<div className="col-md-12 ">
														<div className="tspListBox">
															<div className="tsbBlue text-capitalize" style={{ width: 384 }}>
																<i className="fa"><img src={require('../../images/img/academics.png')} /></i>You rated Dr {appointmentData && appointmentData.doctorId ? appointmentData.doctorId.userName : ''}
															</div>
															<div className="tsbGrayBox">
																{(appointmentData && appointmentData.ratings && appointmentData.ratings.length > 0) ? (appointmentData.ratings).map((item, index) =>
																	<div className="row" key={index}>
																		<div className="col-md-6">
																			<p>{item.ratingQId ? item.ratingQId.question : ''}</p>
																		</div>
																		<div className="col-md-6">
																			<p style={{ fontSize: 20 }}>
																				<StarRatingComponent name="rate2" editing={false} starCount={5} emptyStarColor={'#D3D3D3'}
																					renderStarIcon={(index, value) => {
																						return (
																							<span>
																								{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
																							</span>
																						);
																					}}
																					value={item.value} />
																			</p>
																		</div>
																	</div>
																) : 'You have not added yet'}
																<div className="row">
																	<div className="col-md-6">
																		<p style={{ fontWeight: "bold" }}>Average Rating:</p>
																	</div>
																	<div className="col-md-6">
																		<p style={{ fontSize: 20 }}>
																			<StarRatingComponent name="rate2" editing={false} starCount={5} emptyStarColor={'#D3D3D3'}
																				renderStarIcon={(index, value) => {
																					return (
																						<span>
																							{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
																						</span>
																					);
																				}}
																				value={Math.round(appointmentData.avgRate)} />
																		</p>
																	</div>
																</div>
															</div>
														</div>
													</div>

													: ''}

												{(appointmentData && appointmentData.appointmentStatus == '2' && appointmentData.ratings && appointmentData.ratings.length == 0 && appointmentData.hasOwnProperty('feedbacks') == false) ? < div className="col-md-12 text-center">
													<div className="boxMrgB btnBtm">
														<button style={{ marginLeft: -774 }} type="button" className="btn btn-warning btn-lg btnBtm190" onClick={this.openAddRateModal}>Add Feeback</button>
													</div>
												</div> : ''}


												{(appointmentData && appointmentData.appointmentStatus == '2' && appointmentData.hasOwnProperty('feedbacks') == true && appointmentData.hasOwnProperty('feedbacks') == true != '' && ((appointmentData.feedbacks.isPatientVerified == false && appointmentData.feedbacks.isAdminVerfiedPatientOnce == false) || (appointmentData.feedbacks.isPatientVerified == true && appointmentData.feedbacks.isAdminVerfiedPatientOnce == true))) ?
													<div className="col-md-12 ">
														<div className="tspListBox">
															<div className="tsbBlue text-capitalize" style={{ width: 384 }}>
																<i className="fa"><img src={require('../../images/img/academics.png')} /></i> Your feedback to Dr {appointmentData && appointmentData.doctorId ? appointmentData.doctorId.userName : ''}
															</div>
															<div className="tsbGrayBox">
																<p>{appointmentData.feedbacks ? appointmentData.feedbacks.patientFeedback : ''}</p>
																<p style={{ fontWeight: "bold" }}>Has this feedback been moderated: {appointmentData.feedbacks && appointmentData.feedbacks.isPatientVerified == true ? 'Yes' : 'No'}</p>
															</div>
														</div>
													</div>
													: ''}

												{(appointmentData && appointmentData.appointmentStatus == '2' && appointmentData.hasOwnProperty('feedbacks') == true && appointmentData.hasOwnProperty('feedbacks') == true != '' && appointmentData.feedbacks.isPatientVerified == false && appointmentData.feedbacks.isAdminVerfiedPatientOnce == true) ?
													<div className="col-md-12 ">
														<div className="tspListBox">
															<div className="tsbBlue text-capitalize" style={{ width: 384 }}>
																<i className="fa"><img src={require('../../images/img/academics.png')} /></i> Your feedback to Dr {appointmentData && appointmentData.doctorId ? appointmentData.doctorId.userName : ''}
															</div>
															<div className="tsbGrayBox">
																<p>{appointmentData && appointmentData.feedbacks ? appointmentData.feedbacks.patientFeedback : ''} </p><br />
																<p>Your feedback is rejected by admin you can again give feedback to specialist</p>

																< div className="col-md-12 text-center">
																	<div className="boxMrgB btnBtm">
																		<button style={{ marginLeft: -711 }} type="button" className="btn btn-warning btn-lg btnBtm190" onClick={this.openEditRateModal}>Add Feeback Again</button>
																	</div>
																</div>

															</div>
														</div>
													</div>
													: ''}




												{appointmentData && appointmentData.appointmentStatus == '2' && appointmentData.feedbacks && (appointmentData.feedbacks.hasOwnProperty('doctorFeedback') && appointmentData.feedbacks.doctorFeedback != '') && appointmentData.feedbacks.hasOwnProperty('isSpecialistVerified') && appointmentData.feedbacks.isSpecialistVerified == true ?
													<div className="col-md-12 ">
														<div className="tspListBox">
															<div className="tsbBlue text-capitalize" style={{ width: 450 }}>
																<i className="fa"><img src={require('../../images/img/academics.png')} /></i> Dr {appointmentData && appointmentData.doctorId ? appointmentData.doctorId.userName : ''}  Response to your feedback
														</div>
															<div className="tsbGrayBox">
																<p>{appointmentData.feedbacks ? appointmentData.feedbacks.doctorFeedback : ''}</p>
															</div>
														</div>
													</div> : ''}

												{this.state.isAddRateModalOpen ? <AddRateModal modalOpen={this.state.isAddRateModalOpen} doctorName={this.state.doctorName} appointmentId={this.state.rateAppId} openReminder={this.closeAddRateModal} closeModal={this.closeAddRateModalWithNewData} doctorId={this.state.rateDrId} showStar={false} /> : ''}

												{this.state.isEditRateModalOpen ? <EditRateModal modalOpen={this.state.isEditRateModalOpen} doctorName={this.state.doctorName} appointmentId={this.state.rateAppId} openReminder={this.closeEditRateModal} previousRateData={this.state.rateData}
													closeModal={this.closeEditRateModalWithNewData} editFeedbackId={this.state.feedbackId} previousFeedbackValue={this.state.previousFeedback}
													doctorId={this.state.rateDrId} showStar={false} /> : ''}

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* <div className="disputeHelp"> */}

					<Link className="helpButtonOnAppointment" style={{cursor: 'pointer'}}  /* onClick={() => this.goToDisputePage(appointmentData)} */ to={{
						pathname:`/disputes/${appointmentData && appointmentData._id}`,
						data: {
							data: this.state.appointmentData
						}
					}}>
						{/* <p className="disputeHelp"> */}
							<div className='align-right patientDisputeHelpBtn'>
							<button
							className="btn btn-round btn-w-90"
							>
							<span style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
							</span>
								<span className="btn-text">Help</span>
						</button>
						</div>
				{/* </p> */}
					</Link>
					{/* </div> */}
				</section>
				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div >
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentRateDetail: state.appointment.appointmentRateDetail
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PatientAppointmentDetails);